
import { useRouter } from 'next/router';
import { SSRGlobal } from '../qecomps/Context';
import Img from '../qecomps/Img';

export default (props) => {
  var router = useRouter();

  let z = SSRGlobal()

  if (props.total <= 1) {
    return null
  }

  return <div style={{
    width: "100%", textAlign: "center", marginTop: 20, display: "flex", justifyContent: "center", fontSize: 18,
    direction: "ltr"
  }}>
    <div style={{ display: "flex", height: 35, alignItems: "center" }}>
      <f-cc style={{ opacity: router.query.page ? 1 : 0.2, cursor: "pointer" }}
        onClick={() => {
          if (typeof router.query.page == "string") {
            if (!router.query.page) {
              return;
            }
            else if (parseInt(router.query.page) <= 2) {
              delete router.query.page
              delete router.query.lang
              delete router.query.key

              router.push({ query: { ...router.query } }, router.asPath);
            }
            else {
              delete router.query.lang
              delete router.query.key
              router.push({ query: { ...router.query, page: (Number(router.query.page) - 1).toString() } }, router.asPath);
            }
            props.on?.(router.query.page)
          }

        }}
      >
        <icon class={z.styles.title + ' w-[20px] h-[20px] icon-[fe--arrow-left]'} />
        <sp-2 />
      </f-cc>
      <span style={{ marginBottom: 3 }}>
        {(router.isReady ? (router.query.page ? parseInt(router.query.page as string) : 1) : 1).toLocaleString(z.lang.region)}
        <sp-3 />
        /
        <sp-3 />
        {(props.total || 1).toLocaleString(z.lang.region)}</span>

      <f-cc onClick={() => {
        // router.push(router.asPath+"/1")
        if (!router.isReady) {
          return;
        }
        if (router.query.page >= props.total || props.total <= 1) {
          return
        }
        if (!router.query.page) {
          router.query.page = "2"
        }
        else {
          router.query.page = (Number(router.query.page) + 1).toString();
        }

        delete router.query.lang
        delete router.query.key

        router.push(router, router.asPath)
        props?.on?.(router.query.page)
      }} style={{ opacity: (router.query.page >= props.total || props.total <= 1) ? 0.2 : 1, cursor: "pointer" }}>
        <sp-2 />
        <icon class={z.styles.title + ' w-[20px] h-[20px] icon-[fe--arrow-right]'} />
      </f-cc>
    </div>

  </div>
}


